import * as React from 'react';
import { LocationCheckLog } from 'cb-model';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

/**
 * Location Check Log Search Page
 *
 * Search and list all location check logs (read-only)
 * Shows history of all location checks performed by the system
 */
export const LocationCheckLogSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({ where: { and: LocationCheckLog.defaultFilters } });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(LocationCheckLog, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(LocationCheckLog, queryOptions);

  return (
    <>
      <PageTitle verb="Search" entity={LocationCheckLog} />
      <Section>
        <PaginatorAndListSettings
          entity={LocationCheckLog}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
